import { createSlice } from '@reduxjs/toolkit'

import { getThemes, updatePhrases, postThemes } from 'redux/thunks/Themes'
import { ThemesState } from 'types/TextAnalysis'

const initialState: ThemesState = {
  themes: {
    data: [],
    meta: {},
  },
  selectedTheme: null,
  isExtracting: false,

  status: {
    post: {
      loading: false,
      error: '',
      success: false,
    },
    get: {
      loading: false,
      error: '',
      success: false,
    },
  },
}

const themesSlice = createSlice({
  name: 'TAThemes',
  initialState,
  reducers: {
    setSelectedTheme(state, action) {
      state.selectedTheme = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      // POST themes
      .addCase(postThemes.pending, (state) => {
        state.status.post.loading = true
        state.status.post.success = false
        state.isExtracting = true
        state.status.post.error = ''
        state.themes = { data: [], meta: {} }
      })
      .addCase(postThemes.fulfilled, (state) => {
        state.status.post.loading = false
        state.status.post.success = true
      })
      .addCase(postThemes.rejected, (state, action) => {
        state.status.post.loading = false
        state.isExtracting = false
        state.status.post.error = action.payload || 'Error occurred'
        state.status.post.success = false
      })

      // GET themes
      .addCase(getThemes.pending, (state) => {
        state.status.get.loading = true
        state.status.get.error = ''
        state.status.get.success = false
        if (!state.isExtracting) state.themes = { data: [], meta: {} }
      })
      .addCase(getThemes.fulfilled, (state, action) => {
        state.status.get.loading = false
        state.status.get.success = true
        state.themes = action.payload || { data: [], meta: {} }
        if (
          state.isExtracting &&
          action.payload?.data &&
          action.payload.data.length > 0
        ) {
          state.isExtracting = false
        }
      })
      .addCase(getThemes.rejected, (state, action) => {
        state.status.get.loading = false
        state.status.get.success = false
        state.status.get.error = action.payload || 'Error occurred'
      })

      // Update key phrases in a theme
      .addCase(updatePhrases.fulfilled, (state, action) => {
        const { data } = action.payload
        if (data && data.id) {
          const index = state.themes.data.findIndex(
            (theme: any) => theme.id === data.id,
          )
          if (index !== -1) state.themes.data[index] = data
        }
      })
  },
})

export const { setSelectedTheme } = themesSlice.actions

export default themesSlice.reducer
